import { render, staticRenderFns } from "./GeneralComplaintList.vue?vue&type=template&id=83088ae6&scoped=true&"
import script from "./GeneralComplaintList.vue?vue&type=script&lang=js&"
export * from "./GeneralComplaintList.vue?vue&type=script&lang=js&"
import style0 from "./GeneralComplaintList.vue?vue&type=style&index=0&id=83088ae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83088ae6",
  null
  
)

export default component.exports